// File: src/pages/buyer/AddProduct/sections/ProductMedia.jsx
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import LiveVideoCapture from "../../../../components/seller/LiveVideoCapture.jsx";
import { FaMagic, FaCut, FaExclamationTriangle, FaVideo } from "react-icons/fa";

const ProductMedia = ({
  onAiEdit,
  aiLoading,
  uploadedImage,
  imagePreview,
  setImagePreview,
  setVideoPreview,
  videoPreview,
  kycType,
  isEditMode,
}) => {
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const watchedImageFile = watch("image")?.[0];
  const aiPreviewSrc = watch("aiPreview") || null;
  const [activeAiAction, setActiveAiAction] = useState(null);

  useEffect(() => {
    if (!aiLoading) {
      setActiveAiAction(null);
    }
  }, [aiLoading]);

  const handleAiEdit = (action) => {
    setActiveAiAction(action);
    onAiEdit(action);
  };

  useEffect(() => {
    // Run ONLY when user selects a NEW image (not AI edit)
    if (watchedImageFile && !watch("aiPreview")) {
      const url = URL.createObjectURL(watchedImageFile);
      setImagePreview(url);
      setValue("existingImage", null);
    }
  }, [watchedImageFile, setImagePreview, setValue, watch]);

  // Initialize existing image
  useEffect(() => {
    if (imagePreview && !watchedImageFile) {
      setValue("existingImage", imagePreview);
    }
  }, [imagePreview, watchedImageFile, setValue]);

  return (
    <div className="border rounded p-4 mb-4 bg-white">
      <h5 className="fw-semibold mb-4">Product Media</h5>

      <Row className="g-4">
        {/* Product Image Upload */}
        <Col md={12}>
          <Form.Group>
            <Form.Label>Product Image</Form.Label>
            <Form.Control
              type="file"
              accept=".jpg,.jpeg,.png"
              {...register("image")}
            />
            <input type="hidden" {...register("existingImage")} />
            {errors.image && (
              <div className="text-danger small">{errors.image.message}</div>
            )}
          </Form.Group>
        </Col>

        {/* Image Previews */}
        <Col md={12}>
          <Row className="g-3 flex-nowrap overflow-auto pb-2">
            {/* Uploaded Image (Visible only in Edit mode) */}
            {isEditMode && uploadedImage && (
              <Col md={4} style={{ minWidth: "250px" }}>
                <Form.Label>Uploaded Image</Form.Label>
                <div
                  className="border border-2 rounded d-flex align-items-center justify-content-center"
                  style={{ height: 240, borderStyle: "solid", borderColor: "#198754", backgroundColor: "#f8fffb" }}
                >
                  <img
                    src={uploadedImage}
                    alt="uploaded"
                    className="img-fluid"
                    style={{ maxHeight: "100%", objectFit: "contain" }}
                  />
                </div>
              </Col>
            )}

            {/* New Selection Preview */}
            <Col md={isEditMode && uploadedImage ? 4 : 6} style={{ minWidth: "250px" }}>
              <Form.Label>{isEditMode ? "New Selection" : "Original Preview"}</Form.Label>
              <div
                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                style={{ height: 240 }}
              >
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="preview"
                    className="img-fluid"
                    style={{ maxHeight: "100%", objectFit: "contain" }}
                  />
                ) : (
                  <span className="text-muted">No image selected</span>
                )}
              </div>
            </Col>

            {/* AI Preview */}
            {/* <Col md={isEditMode && uploadedImage ? 4 : 6} style={{ minWidth: "250px" }}>
              <Form.Label>AI Edited Preview</Form.Label>
              <div
                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                style={{ height: 240 }}
              >
                {aiPreviewSrc ? (
                  <img
                    src={aiPreviewSrc}
                    alt="ai-preview"
                    className="img-fluid"
                    style={{ maxHeight: "100%", objectFit: "contain" }}
                  />
                ) : (
                  <span className="text-muted">No AI edit yet</span>
                )}
              </div>
            </Col> */}
          </Row>

          {/* AI Buttons */}
          {/* <div className="d-flex gap-2 mt-3">
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={aiLoading && activeAiAction === "enhance"}
              onClick={() => handleAiEdit("enhance")}
            >
              <span className="d-inline-flex align-items-center gap-1">
                <FaMagic className="me-1" />
                Enhance
                {aiLoading && activeAiAction === "enhance" && (
                  <Spinner size="sm" className="ms-2" />
                )}
              </span>
            </Button>

            <Button
              variant="outline-secondary"
              size="sm"
              disabled={aiLoading && activeAiAction === "remove_bg"}
              onClick={() => handleAiEdit("remove_bg")}
            >
              <span className="d-inline-flex align-items-center gap-1">
                <FaCut className="me-1" />
                Remove BG
              </span>

              {aiLoading && activeAiAction === "remove_bg" && (
                <Spinner size="sm" className="ms-2" />
              )}
            </Button>
          </div> */}
        </Col>

        {/* Product Video */}
        {/* <Col md={12}>
          <Form.Label>Product Video (Live Verification)</Form.Label>

          {isEditMode ? (
            videoPreview ? (
              <LiveVideoCapture defaultVideoUrl={videoPreview} readonly />
            ) : (
              <div className="border border-dashed rounded p-3 text-center text-muted bg-light d-flex justify-content-center align-items-center gap-2">
                <FaExclamationTriangle />
                No verification video available for this product.
              </div>
            )
          ) : (
            <div className="border border-dashed rounded p-3 text-center bg-light text-muted d-flex justify-content-center align-items-center gap-2">
              <FaVideo />A video recording link will be sent to your registered
              email after product creation.
            </div>
          )}

          {kycType === "individual" && (
            <div className="text-danger small mt-2">
              * Note: Video upload is <strong>mandatory</strong> for individual
              KYC users.
            </div>
          )}
        </Col> */}
      </Row>
    </div>
  );
};

export default React.memo(ProductMedia);
